import React, { useState, useEffect } from "react";
import axios from "axios";
import "./PrintLabelPage.css";
import { companiesInfo } from "./companiesInfo";
import html2canvas from "html2canvas";

const PrintLabelPage = () => {
  // State for ledgers and label details
  const [ledgers, setLedgers] = useState([]);
  const [searchTerms, setSearchTerms] = useState(["", ""]);
  const [selectedLedgers, setSelectedLedgers] = useState([null, null]);
  const [labelDetails, setLabelDetails] = useState([null, null]);
  const [selectedCompanies, setSelectedCompanies] = useState([
    "Trumac Healthcare",
    "Trumac Healthcare",
  ]);

  const [, forceUpdate] = useState(); // to force re-render

  useEffect(() => {
    // Fetch ledgers from the API
    const fetchLedgers = async () => {
      try {
        const result = await axios(
          `${process.env.REACT_APP_API_URL}/api/ledger-names`
        );
        setLedgers(result.data);
      } catch (error) {
        console.error("Error fetching ledgers:", error);
      }
    };
    fetchLedgers();
  }, []);

  const handleLedgerSelect = async (index, ledgerName) => {
    const updatedSelectedLedgers = [...selectedLedgers];
    updatedSelectedLedgers[index] = ledgerName;

    const updatedSearchTerms = [...searchTerms];
    updatedSearchTerms[index] = ledgerName;

    setSelectedLedgers(updatedSelectedLedgers);
    setSearchTerms(updatedSearchTerms);

    // Fetch details for the selected ledger
    const result = await axios(
      `${process.env.REACT_APP_API_URL}/api/ledger-details/${ledgerName}`
    );
    const updatedLabelDetails = [...labelDetails];
    updatedLabelDetails[index] = result.data;
    setLabelDetails(updatedLabelDetails);
  };

  const handleSearchChange = (index, event) => {
    const updatedSearchTerms = [...searchTerms];
    updatedSearchTerms[index] = event.target.value;

    const updatedSelectedLedgers = [...selectedLedgers];
    updatedSelectedLedgers[index] = null;

    setSearchTerms(updatedSearchTerms);
    setSelectedLedgers(updatedSelectedLedgers);
  };

  const handleCompanyChange = (index, event) => {
    const updatedSelectedCompanies = [...selectedCompanies];
    updatedSelectedCompanies[index] = event.target.value;
    setSelectedCompanies(updatedSelectedCompanies);
  };

  const downloadImage = (canvas, filename) => {
    const image = canvas.toDataURL("image/png");
    const link = document.createElement("a");
    link.href = image;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const printLabel = async (index) => {
    const label = document.getElementById(`labelToPrint${index}`);
    const button = label.querySelector(".print-button"); // Assuming the button has a class "print-button"

    if (button) button.style.display = "none"; // Temporarily hide the button

    const canvas = await html2canvas(label, {
      scale: 2,
      backgroundColor: null,
    });
    const dataUrl = canvas.toDataURL("image/png");

    // Create an A4 canvas
    const a4Canvas = document.createElement("canvas");
    a4Canvas.width = 595; // A4 width in pixels at 72 DPI
    a4Canvas.height = 842; // A4 height in pixels at 72 DPI
    const ctx = a4Canvas.getContext("2d");

    // Fill the background with white
    ctx.fillStyle = "#FFFFFF";
    ctx.fillRect(0, 0, a4Canvas.width, a4Canvas.height);

    // Calculate scale to fit the label in the top half of A4 page
    const scaleToFit = Math.min(
      (a4Canvas.width - 40) / canvas.width,
      a4Canvas.height / 2 / canvas.height
    );
    const scaledWidth = canvas.width * scaleToFit;
    const scaledHeight = canvas.height * scaleToFit;

    // Draw the label on the A4 canvas
    ctx.drawImage(
      canvas,
      (a4Canvas.width - scaledWidth) / 2,
      a4Canvas.height / 4 - scaledHeight / 2,
      scaledWidth,
      scaledHeight
    );

    if (button) button.style.display = ""; // Show the button again

    // // Download the A4 canvas as an image
    // const a4DataUrl = a4Canvas.toDataURL("image/png");
    // const link = document.createElement("a");
    // link.href = a4DataUrl;
    // link.download = `label-${index + 1}.png`;
    // document.body.appendChild(link); // Required for Firefox
    // link.click();
    // document.body.removeChild(link);

    // Open a new window or use an existing iframe to display the image
    const printWindow = window.open(
      "",
      "PRINT",
      "height=650,width=900,top=100,left=150"
    );

    printWindow.document.write("<html><head><title>Print</title></head><body>");
    printWindow.document.write(
      '<img src="' +
        canvas.toDataURL("image/png") +
        '" style="width:100%; max-width:800px;">'
    );
    printWindow.document.write("</body></html>");

    printWindow.document.close(); // Necessary for some browsers
    printWindow.focus(); // Necessary for some browsers

    // Wait a short time before printing to ensure the image is loaded
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 500);
  };

  const printBothLabels = async () => {
    const labels = [
      document.getElementById("labelToPrint0"),
      document.getElementById("labelToPrint1"),
    ];

    // Temporarily hide the download buttons
    const buttons = labels.map((label) => label.querySelector(".print-button"));
    buttons.forEach((button) => (button.style.display = "none"));

    const canvases = await Promise.all(
      labels.map((label) =>
        html2canvas(label, { scale: 2, backgroundColor: null })
      )
    );

    // Calculate the total height needed for both labels with a margin
    const totalHeight = canvases[0].height + canvases[1].height + 20; // 20px margin

    // Create a combined canvas to fit within A4 size more effectively
    const combinedCanvas = document.createElement("canvas");
    combinedCanvas.width = 595; // A4 width in pixels at 72 DPI
    combinedCanvas.height = 842; // A4 height in pixels at 72 DPI

    const ctx = combinedCanvas.getContext("2d");
    ctx.fillStyle = "#FFFFFF"; // White background
    ctx.fillRect(0, 0, combinedCanvas.width, combinedCanvas.height); // Fill background

    // Calculate new scale to fit both labels within the A4 page more effectively
    const scaleToFit = Math.min(
      combinedCanvas.width / canvases[0].width,
      combinedCanvas.height / totalHeight
    );
    const scaledHeight1 = canvases[0].height * scaleToFit;
    const scaledHeight2 = canvases[1].height * scaleToFit;
    const scaledWidth1 = canvases[0].width * scaleToFit;
    const scaledWidth2 = canvases[1].width * scaleToFit;

    // Draw the first label, centered horizontally
    ctx.drawImage(
      canvases[0],
      (combinedCanvas.width - scaledWidth1) / 2,
      0,
      scaledWidth1,
      scaledHeight1
    );

    // Draw the second label below the first, with a small margin, centered horizontally
    ctx.drawImage(
      canvases[1],
      (combinedCanvas.width - scaledWidth2) / 2,
      scaledHeight1 + 20,
      scaledWidth2,
      scaledHeight2
    );

    // Show the download buttons again
    buttons.forEach((button) => (button.style.display = ""));

    // Convert combined canvas to data URL for printing
    const dataUrl = combinedCanvas.toDataURL("image/png");

    // Open a new window or tab for printing
    const printWindow = window.open("", "_blank");
    printWindow.document.write(
      `<html><head><title>Print Labels</title></head><body><img src="${dataUrl}" style="width: 100%; height: auto;"></body></html>`
    );
    printWindow.document.close();
    printWindow.focus();

    // Wait for the image to load before printing
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 1000);
  };

  return (
    <div className="print-label-page">
      <div className="labels-wrapper">
        {Array.from({ length: 2 }, (_, index) => (
          <div className="label-section" key={index}>
            <div className="ledger-search-container">
              <input
                type="text"
                value={searchTerms[index]}
                onChange={(event) => handleSearchChange(index, event)}
                placeholder="Search ledger..."
              />
              {searchTerms[index] && !selectedLedgers[index] && (
                <div className="search-results">
                  {ledgers
                    .filter((ledger) =>
                      ledger.ledger_name
                        .toLowerCase()
                        .includes(searchTerms[index].toLowerCase())
                    )
                    .map((ledger) => (
                      <div
                        key={ledger.id}
                        className="search-result-item"
                        onClick={() =>
                          handleLedgerSelect(index, ledger.ledger_name)
                        }
                      >
                        {ledger.ledger_name}
                      </div>
                    ))}
                </div>
              )}
            </div>
            <div className="company-select-container">
              <select
                value={selectedCompanies[index]}
                onChange={(event) => handleCompanyChange(index, event)}
              >
                {Object.keys(companiesInfo).map((company) => (
                  <option key={company} value={company}>
                    {company}
                  </option>
                ))}
              </select>
            </div>
            {selectedLedgers[index] && labelDetails[index] && (
              <div
                key={labelDetails[index].id || labelDetails[index].ledger_name} // Use a unique key from ledger details
                id={`labelToPrint${index}`}
                className="label-container"
              >
                {/* Rest of the code for displaying label details */}
                {/* <div className="label-header"> */}
                <div
                  className="label-header editable"
                  contentEditable
                  suppressContentEditableWarning={true}
                  //   onBlur={(e) => handleContentChange(index, "ledger_name", e)}
                >
                  {labelDetails[index].ledger_name.toUpperCase()}
                </div>
                {/* <div className="label-address"> */}
                <div
                  className="label-address editable"
                  contentEditable
                  suppressContentEditableWarning={true}
                  //   onBlur={(e) => handleContentChange(index, "address", e)}
                >
                  <strong>Address : </strong>
                  {labelDetails[index].address}
                </div>
                {/* <div className="label-city"> */}
                <div
                  className="label-city editable"
                  contentEditable
                  suppressContentEditableWarning={true}
                  //   onBlur={(e) => handleContentChange(index, "city", e)}
                >
                  <strong>Station : </strong>
                  {labelDetails[index].city.toUpperCase()}
                  {" , "}
                  {labelDetails[index].state.toUpperCase()}
                </div>
                {/* <div className="label-pin"> */}
                <div
                  className="label-pin editable"
                  contentEditable
                  suppressContentEditableWarning={true}
                  //   onBlur={(e) => handleContentChange(index, "pin_codd", e)}
                >
                  <strong>Pin Code : </strong>
                  {labelDetails[index].pin_code}
                </div>
                {/* <div className="label-phone"> */}
                <div
                  className="label-phone editable"
                  contentEditable
                  suppressContentEditableWarning={true}
                  //   onBlur={(e) => handleContentChange(index, "phone1", e)}
                >
                  <strong>Contact : </strong>
                  {[
                    labelDetails[index].phone1,
                    labelDetails[index].phone2,
                    labelDetails[index].phone3,
                    labelDetails[index].phone4,
                  ]
                    .filter((phone) => phone !== "NULL" && phone !== "") // Filter out null or empty phone numbers
                    .join(", ")}
                </div>
                <div className="label-from">
                  <div className="separator"></div> {/* Separator */}
                  <strong>From:</strong>
                  <div className="company-name">
                    {companiesInfo[selectedCompanies[index]].name}
                  </div>
                  <div>{companiesInfo[selectedCompanies[index]].address}</div>
                  <div>
                    Website: {companiesInfo[selectedCompanies[index]].website}
                  </div>
                </div>
                <button
                  onClick={() => printLabel(index)}
                  className="print-button"
                >
                  Print Label
                </button>
              </div>
            )}
          </div>
        ))}
      </div>
      {labelDetails[0] && labelDetails[1] && (
        <div className="download-both-container">
          <button className="print-both-button" onClick={printBothLabels}>
            Print Both Labels
          </button>
        </div>
      )}
    </div>
  );
};

export default PrintLabelPage;
